import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  constructor(@Inject(DOCUMENT) private document: Document) {}
  shareOnFacebook(shareUrl: string) {
    if (typeof window !== 'undefined') {
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(shareUrl),
        '_blank',
      );
    }
  }

  shareOnLinkedIn(shareUrl: string) {
    if (typeof window !== 'undefined') {
      window.open(
        'https://www.linkedin.com/sharing/share-offsite/?url=' +
          encodeURIComponent(shareUrl),
        '_blank',
      );
    }
  }
  shareOnInstagram(shareUrl: string) {
    const instagramShareUrl = `https://www.instagram.com/create/caption/?${encodeURIComponent(shareUrl)}`;

    this.document.location.href = instagramShareUrl;
  }

  shareOnTwitter(shareUrl: string) {
    const text = 'Ressources et outils pour investisseurs intelligents'; // Text to include in the tweet

    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(text)}`;

    this.document.location.href = twitterShareUrl;
  }
}
